export const EMAIL_VALIDATOR = "^[\\w\\d\\._%+-]+@[\\w\\d\\.-]+\\.[\\w]+$";
export const PASSWORD_VALIDATOR = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$";
export const OFFER_NAME_VALIDATOR = "^[\\w\\d.,-/#!?$%' \"^&*;:{}=_`~()-]+$";